export type User = {
  user_permissions: string[]
  organization_permissions: Record<string, string[]>  // JSON keys are strings
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  is_staff: boolean;
  id: number;
}

export type UserMinimal = {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  is_staff: boolean;
}

export type EmailRecipient = UserMinimal & {
  is_opted_in: boolean;
  is_snoozed: boolean;
}

export enum OrganizationRole {
  ADMIN = 'admin',
  VIEWER = 'viewer',
  INSTALLER = 'installer',
}

export type OrganizationMembership = {
  id: number;
  user: {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    email: string;
  };
  role: OrganizationRole;
  organization: number;
}

export const hasPermission = (user: User, permission_to_test: string): boolean => {
  return user.is_staff || user.user_permissions.some(user_permission => user_permission.includes(permission_to_test));
}

export const hasOrgPermission = (user: User, organizationId: number, permission: string): boolean => {
  // Staff users have all permissions
  if (user.is_staff) {
    return true;
  }

  // Check if user has the specific permission for this organization
  // Note: JSON keys are strings, so convert organizationId to string
  const orgPermissions = user.organization_permissions[organizationId.toString()] || [];
  return orgPermissions.includes(permission);
}

export const isInstallerOnly = (user: User, organizationId: number): boolean => {
  // Staff users are never installer-only
  if (user.is_staff) {
    return false;
  }

  // Installer-only users lack view_organization_data permission
  return !hasOrgPermission(user, organizationId, 'sensorkit_meta.view_organization_data');
}
